module.exports = __webpack_public_path__ + "static/media/diktat-6.ac9604c2.mp3";